module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA+UlEQVRYR+2VsQ3CMBBF/5+DBokBmIaMQElBwxgUSEisQLahRqJjAQY4ZJREFzC2z0mUxqmte08v8YWY+eHMfBSBUqAU6AqIyAXAFsCJ5G6K66kYR5J7x/gIiMgKwF1Ba5LVmBIicgWwUTPXJG+6wAPAcgoJD/xJctEVaCo4O2epn8ElPHA3vyJZ9wSmkIjBfwTGlEiBewXGkEiF/xUYImGBBwVyJKzwqIBFIgeeJJAikQtPFghJNEtDb7jePY9tU9PfUER8y+qb0S2ZGNxUoB0WkTDBswQCr8MMzxZQEgcALwDndrenZNdnTN+AdXjK+SJQCpQCsxd4Ay9kiSE8Z5lJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down.png
// module id = jIOt
// module chunks = 14